function connectScrogNewsletter(form, getResult, restoreResult, revealReward, prepareSubmission = () => {}) {
  const field = (id) => form.querySelector(`#${id}`);
  const button = field('newsletterSubmitButton');
  const message = field('newsletterMessage');
  const key = 'scrog-newsletter-return-v1';
  const ttl = 30 * 60 * 1000;
  const resultState = form.querySelector('[data-newsletter-result]').dataset.newsletterResult;
  let timer;

  function readPending() {
    try {
      const value = JSON.parse(sessionStorage.getItem(key));
      if (!value || !Number.isFinite(value.createdAt) || Date.now() - value.createdAt > ttl || Date.now() < value.createdAt
        || !Number.isInteger(value.score) || value.score < 0 || value.score > 1000000
        || !Number.isInteger(value.level) || value.level < 1 || value.level > 3
        || !Number.isInteger(value.misses) || value.misses < 0 || value.misses > 5
        || !Number.isFinite(value.roundElapsed) || value.roundElapsed < 0 || value.roundElapsed > 60000
        || (value.highscoreSaved !== undefined && typeof value.highscoreSaved !== 'boolean')
        || typeof value.eligible !== 'boolean' || (value.eligible && (value.level !== 3 || value.roundElapsed < 60000))) return null;
      return value;
    } catch { return null; }
  }

  function reset(eligible) {
    clearTimeout(timer);
    form.reset();
    button.disabled = false;
    button.textContent = eligible ? 'Anmelden & entdecken' : 'Zum Newsletter anmelden';
    field('newsletterHeading').textContent = eligible ? 'Runde 3 geschafft – lüfte das Geheimnis!' : 'Schalte deine Überraschung frei';
    field('newsletterCopy').textContent = eligible
      ? 'Melde dich zum Growber-Newsletter an und entdecke deine erspielte Überraschung.'
      : 'Schließe Runde 3 ab und melde dich zum Newsletter an. Dann erfährst du, welche Überraschung auf dich wartet.';
    message.textContent = '';
  }

  function submit(event) {
    if (!form.reportValidity() || !field('newsletterOptIn').checked) {
      event.preventDefault();
      return;
    }
    try {
      // Persist game values only; never persist email, consent text or player identity.
      sessionStorage.setItem(key, JSON.stringify({ ...getResult(), createdAt: Date.now() }));
    } catch {
      event.preventDefault();
      message.textContent = 'Dein Browser blockiert die Rückkehr zum Spielergebnis. Bitte erlaube den Sitzungsspeicher und versuche es erneut.';
      return;
    }
    clearTimeout(timer);
    button.disabled = true;
    button.textContent = 'Wird übermittelt …';
    prepareSubmission();
    // Native submission preserves Shopify spam protection and server-side errors.
    timer = setTimeout(() => {
      button.disabled = false;
      button.textContent = 'Erneut versuchen';
      message.textContent = 'Noch keine Bestätigung. Schließe gegebenenfalls die Sicherheitsprüfung ab oder versuche es erneut.';
    }, 20000);
  }

  function resume() {
    const pending = readPending();
    if (!pending) {
      try { sessionStorage.removeItem(key); } catch {}
      return;
    }
    // A fresh response from this Liquid form is required, not a URL success flag.
    if (resultState !== 'success' && resultState !== 'error') return;
    try { sessionStorage.removeItem(key); } catch {}
    restoreResult(pending);
    if (resultState === 'success') {
      field('newsletterEmail').value = '';
      field('newsletterEmail').defaultValue = '';
      button.disabled = true;
      button.textContent = 'Anmeldung übermittelt';
      message.textContent = 'Shopify hat deine Anmeldung entgegengenommen. Falls du eine Bestätigungsmail erhältst, bestätige darin deine Newsletter-Anmeldung.';
      if (pending.eligible) revealReward();
    } else {
      message.textContent = 'Die Anmeldung konnte nicht abgeschlossen werden. Prüfe die Hinweise und versuche es erneut.';
    }
  }

  return { reset, submit, resume, dispose: () => clearTimeout(timer) };
}


function createScrogHighscores(endpoint) {
  const key = 'scrog-highscore-run-v1';
  let token = null;
  let generation = 0;
  let pending = Promise.resolve(null);
  let disposed = false;
  const requests = new Set();
  let url;
  try {
    url = new URL(endpoint);
    if (url.protocol !== 'https:' && !(['localhost', '127.0.0.1'].includes(url.hostname) && url.protocol === 'http:')) url = null;
    if (url && (url.username || url.password || url.hash || url.search)) url = null;
  } catch { url = null; }

  async function request(action, body) {
    if (!url) throw new Error('Die gemeinsame Highscore ist noch nicht verbunden.');
    if (disposed) throw new Error('Das Spiel wurde geschlossen.');
    const controller = new AbortController();
    requests.add(controller);
    const timer = setTimeout(() => controller.abort(), 8000);
    try {
      const target = new URL(url); target.searchParams.set('action', action);
      const response = await fetch(target, {
        method: body === undefined ? 'GET' : 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
        signal: controller.signal, headers: body === undefined ? {} : {'Content-Type': 'application/json'},
        body: body === undefined ? undefined : JSON.stringify(body)
      });
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.error === 'string' ? data.error.slice(0, 180) : 'Speichern fehlgeschlagen. Bitte erneut versuchen.');
      return data;
    } catch (error) {
      if (error.name === 'AbortError' || error instanceof TypeError || error instanceof SyntaxError) throw new Error('Die Highscore ist gerade nicht erreichbar. Bitte versuche es erneut.');
      throw error;
    } finally { clearTimeout(timer); requests.delete(controller); }
  }

  function start() {
    const current = ++generation;
    token = null;
    try { sessionStorage.removeItem(key); } catch {}
    pending = request('runs', {}).then(data => {
      if (!/^[a-f0-9]{32}\.\d{10}\.[a-f0-9]{64}$/.test(data.token) || !Number.isFinite(data.expiresAt)) throw new Error('Die Spielrunde konnte nicht registriert werden.');
      if (current !== generation || disposed) return null;
      token = data.token;
      try { sessionStorage.setItem(key, JSON.stringify({token, expiresAt: data.expiresAt})); } catch {}
      return token;
    }).catch(() => null);
    return pending;
  }

  function restore() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(key));
      if (saved && /^[a-f0-9]{32}\.\d{10}\.[a-f0-9]{64}$/.test(saved.token) && saved.expiresAt * 1000 > Date.now()) token = saved.token;
    } catch {}
    pending = Promise.resolve(token);
  }

  const validEntry = entry => entry && typeof entry.id === 'string' && typeof entry.name === 'string'
    && entry.name.length <= 48 && Number.isInteger(entry.score) && entry.score >= 0 && entry.score <= 250000;
  return {
    start, restore,
    async list() {
      const data = await request('leaderboard');
      if (!Array.isArray(data.entries) || data.entries.length > 10 || !data.entries.every(validEntry)) throw new Error('Die Rangliste konnte nicht geladen werden.');
      return data.entries;
    },
    async save(result) {
      const activeToken = await pending;
      if (!activeToken) throw new Error('Diese Runde war nicht mit der Highscore verbunden. Bitte starte bei bestehender Verbindung eine neue Runde.');
      const data = await request('scores', {...result, token: activeToken});
      if (!validEntry(data.entry)) throw new Error('Speicherung nicht bestätigt. Bitte erneut versuchen.');
      return data.entry;
    },
    dispose() { disposed = true; generation++; for (const controller of requests) controller.abort(); }
  };
}

    function mountScrogGame(root, host) {
const lifecycle = new AbortController();
const findElement = (id) => root.getElementById(id) || host.querySelector(`#${id}`);
      "use strict";

      const canvas = findElement("scrogCanvas");
      const ctx = canvas.getContext("2d");
      const playArea = findElement("playArea");
      const overlay = findElement("gameOverlay");
      const overlayTitle = findElement("overlayTitle");
      const overlayText = findElement("overlayText");
      const overlayButton = findElement("overlayButton");
      const primaryButton = findElement("primaryButton");
      const pauseButton = findElement("pauseButton");
      const pauseButtonLabel = findElement("pauseButtonLabel");
      const shopButton = findElement("shopButton");
      const scoreValue = findElement("scoreValue");
      const timeValue = findElement("timeValue");
      const levelValue = findElement("levelValue");
      const missesValue = findElement("missesValue");
      const gridValue = findElement("gridValue");
      const progressTrack = findElement("progressTrack");
      const progressFill = findElement("progressFill");
      const statusLine = findElement("statusLine");
      const screenReaderState = findElement("screenReaderState");
      const highscoreOverlay = findElement("highscoreOverlay");
      const resultHeading = findElement("resultHeading");
      const resultCopy = findElement("resultCopy");
      const scoreForm = findElement("scoreForm");
      const playerName = findElement("playerName");
      const newsletterOptIn = findElement("newsletterOptIn");
      const newsletterEmail = findElement("newsletterEmail");
      const newsletterForm = findElement("newsletterForm");
      const newsletterHeading = findElement("newsletterHeading");
      const newsletterCopy = findElement("newsletterCopy");
      const newsletterSubmitButton = findElement("newsletterSubmitButton");
      const newsletterMessage = findElement("newsletterMessage");
      const rewardBox = findElement("rewardBox");
      const rewardCode = findElement("rewardCode");
      const openHighscoreButton = findElement("openHighscoreButton");
      const closeHighscoreButton = findElement("closeHighscoreButton");
      const inviteButton = findElement("inviteButton");
      const resultInviteButton = findElement("resultInviteButton");
      const formMessage = findElement("formMessage");
      const saveScoreButton = findElement("saveScoreButton");
      const skipScoreButton = findElement("skipScoreButton");
      const resultEntryActions = findElement("resultEntryActions");
      const leaderboardList = findElement("leaderboardList");
      const clearScoresButton = findElement("clearScoresButton");
      const soundButton = findElement("soundButton");
      const soundButtonLabel = findElement("soundButtonLabel");
      const backgroundMusic = findElement("backgroundMusic");
      const cutSound = findElement("cutSound");

      const ROUND_DURATION = 60000;
      const MAX_MISSES = 5;
      const REWARD_CODE = "#SCROGMASTER";
      const BOARD_MARGIN = 40;
      const LEVELS = [
        { columns: 6, rows: 6, interval: 1180, lifetime: 4200, maximum: 3 },
        { columns: 8, rows: 8, interval: 900, lifetime: 3500, maximum: 4 },
        { columns: 10, rows: 10, interval: 680, lifetime: 2900, maximum: 5 }
      ];
      const HARVEST_QUIPS = {
        small: [
          ["Oma lässt grüßen!", "Deine Oma schafft das mit der Salatschere. Revanche?"],
          ["War das schon die Ernte?", "Die Schere war wohl noch im Karton. Nochmal ran!"],
          ["Immerhin: schön luftig!", "Dein Netz hat noch Platz für große Träume. Nächster Versuch!"],
          ["Die Triebe gewinnen diese Runde.", "Die haben sich schon gemütlich eingerichtet. Zeig ihnen die Schere!"]
        ],
        medium: [
          ["Da geht noch was!", "Oma legt gerade ihre Salatschere weg. Jetzt wird’s ernst."],
          ["Die Schere ist warm!", "Dein grüner Daumen hat nur noch etwas Ladehemmung. Nochmal!"],
          ["Ganz schön schnittig!", "Für den Titel Scrogmaster fehlt noch ein bisschen Schnipp-Schnapp."],
          ["Fast schon Familienrekord!", "Oma behauptet natürlich, sie hätte mehr geschafft. Revanche?"]
        ],
        large: [
          ["Die Waage wird nervös!", "Langsam braucht die Waage Verstärkung. Geht da noch mehr?"],
          ["Oma will ein Autogramm!", "Die Salatschere hängt sie jetzt wohl an den Nagel."],
          ["Grüner Daumen? Ganze Hand!", "Deine Schere beantragt gerade eine Kaffeepause."],
          ["Wer hat hier den Turbo an?", "Die Triebe erzählen sich schon Gruselgeschichten über Dich."]
        ],
        completed: [
          ["Scrogmaster! Oma ist stolz.", "Drei Runden geschafft. Die Salatschere geht feierlich in Rente."],
          ["Das Netz zieht den Hut!", "Drei Runden geschafft. Deine Schere möchte jetzt Urlaub."],
          ["Du hast das Netz im Griff!", "Drei Runden geschafft. Die Triebe haben Deinen Namen auf der Warnliste."],
          ["Oma fragt nach Deinem Trick!", "Drei Runden geschafft. Verrat ihr bloß nicht, dass es nur Klicks waren."]
        ]
      };
      const highscores = createScrogHighscores(host.dataset.highscoreUrl || "");
      const leaderboardStatus = findElement("leaderboardStatus");
      let scoreGeneration = 0;
      let leaderboardRequest = 0;
      let savingHighscore = false;
      let highscoreSaved = false;

      let columns = LEVELS[0].columns;
      let rows = LEVELS[0].rows;
      let compactBoard = null;
      let mode = "idle";
      let score = 0;
      let misses = 0;
      let roundElapsed = 0;
      let level = 1;
      let lastFrame = 0;
      let spawnAccumulator = 0;
      let nextSpawnDelay = LEVELS[0].interval;
      let animationFrame = 0;
      let targets = [];
      let feedback = [];
      let canopy = [];
      let sceneryCache = null;
      const hudValues = new Map();
      let lastSavedEntry = null;
      let soundEnabled = true;
      let audioContext = null;
      let rewardEligible = false;
      let pausedAt = 0;
      let dialogReturnFocus = null;
      let resultActionTimer = 0;
      let resultActionsReadyAt = 0;
      let newsletterBackend = null;
      let lastHarvestQuip = null;

      function resetNewsletter() {
        if (newsletterBackend) {
          newsletterBackend.reset(rewardEligible);
          rewardBox.hidden = true;
          rewardCode.textContent = "";
          return;
        }
        newsletterForm.reset();
        newsletterSubmitButton.disabled = false;
        newsletterSubmitButton.textContent = rewardEligible ? "Newsletter testen & entdecken" : "Newsletter testen";
        newsletterHeading.textContent = rewardEligible ? "Runde 3 geschafft – lüfte das Geheimnis!" : "Schalte deine Überraschung frei";
        newsletterCopy.textContent = rewardEligible
          ? "Teste die Newsletter-Anmeldung und entdecke deine erspielte Überraschung."
          : "Schließe Runde 3 ab. Danach kannst du mit dem Newsletter-Test deine Überraschung entdecken.";
        newsletterMessage.textContent = "";
        rewardBox.hidden = true;
        rewardCode.textContent = "";
      }

      function submitNewsletter(event) {
        if (newsletterBackend) return newsletterBackend.submit(event);
        event.preventDefault();
        if (!newsletterForm.reportValidity()) return;
        // This local preview validates input only; no email is stored or transmitted.
        newsletterEmail.value = "";
        newsletterSubmitButton.disabled = true;
        newsletterSubmitButton.textContent = "Vorschau getestet";
        newsletterMessage.textContent = "Eingabe geprüft. In dieser lokalen Vorschau wird noch kein Newsletter bestellt.";
        if (rewardEligible) {
          rewardCode.textContent = REWARD_CODE;
          rewardBox.hidden = false;
        }
      }

      async function inviteFriends(event) {
        const message = findElement(event.currentTarget === resultInviteButton ? "resultInviteMessage" : "inviteMessage");
        const url = new URL(window.location.href);
        const isLocal = ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname) || !["https:", "http:"].includes(url.protocol);
        if (isLocal) {
          message.textContent = "Freunde einladen ist verfügbar, sobald das Spiel im Shop online ist.";
          return;
        }
        const previewId = url.searchParams.get("preview_theme_id");
        url.search = "";
        if (previewId) url.searchParams.set("preview_theme_id", previewId);
        url.hash = "betternet-scrog-hero";
        const title = "Betternet SCROG Hero";
        const text = "Schaffst du Runde 3? Spiel Betternet SCROG Hero und knack meinen Ernte-Highscore. Eine Überraschung wartet auf dich – schalte sie mit deiner eigenen Runde 3 und der Newsletter-Anmeldung frei!";
        try {
          if (navigator.share) {
            await navigator.share({ title, text, url: url.href });
            message.textContent = "Einladung geteilt.";
          } else if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(`${text} ${url.href}`);
            message.textContent = "Einladungslink kopiert – schick ihn deinen Freunden!";
          } else {
            message.textContent = `Einladungslink zum Kopieren: ${url.href}`;
          }
        } catch (error) {
          if (error.name !== "AbortError") message.textContent = `Einladungslink zum Kopieren: ${url.href}`;
        }
      }

      function showHighscore() {
        dialogReturnFocus = (root.activeElement || document.activeElement);
        if (mode === "running") pauseGame();
        if (mode !== "ended") {
          highscoreOverlay.classList.add("browse-mode");
          resultHeading.textContent = "Highscore";
          resultCopy.textContent = "Die besten Ernten. Nach dem Spiel kannst du dich selbst eintragen – unabhängig von deinem Ergebnis.";
          scoreForm.hidden = true;
          newsletterForm.hidden = true;
          rewardBox.hidden = true;
          resultEntryActions.hidden = true;
        }
        renderLeaderboard();
        highscoreOverlay.hidden = false;
        if (!highscoreOverlay.open) highscoreOverlay.showModal();
        playArea.inert = true;
        root.querySelector(".hud").inert = true;
        closeHighscoreButton.focus();
      }

      function closeHighscore() {
        highscoreOverlay.close();
        highscoreOverlay.hidden = true;
        playArea.inert = false;
        root.querySelector(".hud").inert = false;
        newsletterEmail.value = "";
        (dialogReturnFocus || openHighscoreButton).focus({ preventScroll: true });
      }

      function isCompactInput() {
        return compactBoard || window.matchMedia("(pointer: coarse)").matches;
      }

      function targetSpacing(board) {
        const rect = canvas.getBoundingClientRect();
        return { x: board.width / columns * rect.width / canvas.width, y: board.height / rows * rect.height / canvas.height };
      }

      backgroundMusic.volume = 0.12;
      cutSound.volume = 0.43;

      function startBackgroundMusic(restart = false) {
        if (!soundEnabled || mode !== "running") return;
        if (restart) backgroundMusic.currentTime = 0;
        const playAttempt = backgroundMusic.play();
        if (playAttempt && typeof playAttempt.catch === "function") {
          playAttempt.catch((error) => {
            if (error.name !== "AbortError") {
              statusLine.textContent = "Die Musik konnte nicht gestartet werden. Das Spiel läuft ohne Musik weiter.";
            }
          });
        }
      }

      function pauseBackgroundMusic(reset = false) {
        backgroundMusic.pause();
        if (reset) backgroundMusic.currentTime = 0;
      }

      function playCutSound() {
        if (!soundEnabled) return;
        cutSound.currentTime = 0;
        const playAttempt = cutSound.play();
        if (playAttempt && typeof playAttempt.catch === "function") {
          playAttempt.catch(() => {});
        }
      }

      function seededRandom(index) {
        const value = Math.sin(index * 91.731 + 17.17) * 43758.5453;
        return value - Math.floor(value);
      }

      function getAudioContext() {
        if (!soundEnabled) return null;
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return null;
        if (!audioContext) audioContext = new AudioContextClass();
        if (audioContext.state === "suspended") audioContext.resume().catch(() => {});
        return audioContext;
      }

      function playSound(cue) {
        const audio = getAudioContext();
        if (!audio) return;

        const patterns = {
          start: [[392, 0, 0.07], [523, 0.08, 0.09]],
          hit: [[440, 0, 0.055], [659, 0.055, 0.075]],
          bonus: [[587, 0, 0.06], [880, 0.06, 0.08], [1175, 0.14, 0.09]],
          gold: [[659, 0, 0.07], [988, 0.07, 0.09], [1319, 0.16, 0.13]],
          miss: [[196, 0, 0.34, "sawtooth", 65], [208, 0.025, 0.37, "sawtooth", 69], [98, 0.10, 0.34, "triangle", 43]],
          round: [[523, 0, 0.09], [659, 0.1, 0.09], [784, 0.2, 0.14]],
          finish: [[523, 0, 0.12], [659, 0.05, 0.15], [784, 0.1, 0.2]],
          end: [[294, 0, 0.13], [247, 0.14, 0.18]]
        };

        const notes = patterns[cue] || [];
        notes.forEach(([frequency, delay, duration, wave = "sine", endFrequency = frequency]) => {
          const oscillator = audio.createOscillator();
          const gain = audio.createGain();
          const startAt = audio.currentTime + delay;
          oscillator.type = wave;
          oscillator.frequency.setValueAtTime(frequency, startAt);
          oscillator.frequency.exponentialRampToValueAtTime(Math.max(30, endFrequency), startAt + duration);
          gain.gain.setValueAtTime(0.0001, startAt);
          gain.gain.exponentialRampToValueAtTime(cue === "miss" ? 0.045 : 0.055, startAt + 0.012);
          gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
          oscillator.connect(gain);
          gain.connect(audio.destination);
          oscillator.start(startAt);
          oscillator.stop(startAt + duration + 0.02);
        });
      }

      function rebuildCanopy() {
        sceneryCache = null;
        const count = compactBoard ? 38 : 74;
        canopy = Array.from({ length: count }, (_, index) => ({
          x: seededRandom(index * 7 + 1),
          y: seededRandom(index * 7 + 2),
          size: 0.55 + seededRandom(index * 7 + 3) * 0.7,
          rotation: seededRandom(index * 7 + 4) * Math.PI * 2,
          tone: index % 4
        }));
      }

      function configureBoard() {
        const nextCompactBoard = host.clientWidth <= 620;
        if (nextCompactBoard === compactBoard && canopy.length) return;

        compactBoard = nextCompactBoard;
        canvas.width = compactBoard ? 780 : 1480;
        canvas.height = 780;
        playArea.style.setProperty("--game-ratio", `${canvas.width} / ${canvas.height}`);
        targets = [];
        feedback = [];
        spawnAccumulator = 0;
        rebuildCanopy();
        updateHud();
        render();
      }

      function getBoard() {
        return {
          x: BOARD_MARGIN,
          y: BOARD_MARGIN,
          width: canvas.width - BOARD_MARGIN * 2,
          height: canvas.height - BOARD_MARGIN * 2
        };
      }

      function drawLeafCluster(x, y, radius, rotation, paletteIndex = 0, alpha = 1, paint = ctx) {
        const greens = [
          ["#245f23", "#4fa62a"],
          ["#174c20", "#3d8d28"],
          ["#2b6d25", "#61b932"],
          ["#1d5721", "#4b9828"],
          ["#a45d00", "#ffd83d"]
        ];
        const palette = greens[paletteIndex % greens.length];

        paint.save();
        paint.translate(x, y);
        paint.rotate(rotation);
        paint.globalAlpha = alpha;

        for (let index = 0; index < 7; index += 1) {
          const angle = (Math.PI * 2 * index) / 7;
          paint.save();
          paint.rotate(angle);
          const gradient = paint.createLinearGradient(0, 0, 0, -radius);
          gradient.addColorStop(0, palette[0]);
          gradient.addColorStop(1, palette[1]);
          paint.fillStyle = gradient;
          paint.beginPath();
          paint.moveTo(0, 3);
          paint.bezierCurveTo(radius * 0.38, -radius * 0.30, radius * 0.22, -radius * 0.82, 0, -radius);
          paint.bezierCurveTo(-radius * 0.22, -radius * 0.82, -radius * 0.38, -radius * 0.30, 0, 3);
          paint.fill();
          paint.restore();
        }

        paint.fillStyle = "#9bcf3b";
        paint.beginPath();
        paint.arc(0, 0, Math.max(2.5, radius * 0.12), 0, Math.PI * 2);
        paint.fill();
        paint.restore();
      }

      function drawCanopy(board, paint = ctx) {
        const background = paint.createLinearGradient(board.x, board.y, board.x, board.y + board.height);
        background.addColorStop(0, "#152718");
        background.addColorStop(1, "#071108");
        paint.fillStyle = background;
        paint.fillRect(board.x, board.y, board.width, board.height);

        paint.save();
        paint.beginPath();
        paint.rect(board.x, board.y, board.width, board.height);
        paint.clip();
        canopy.forEach((leaf) => {
          const x = board.x + leaf.x * board.width;
          const y = board.y + leaf.y * board.height;
          const cellWidth = board.width / columns;
          const cellHeight = board.height / rows;
          const radius = Math.min(cellWidth, cellHeight) * 0.52 * leaf.size;
          drawLeafCluster(x, y, radius, leaf.rotation, leaf.tone, 0.66, paint);
        });

        paint.fillStyle = "rgba(3, 10, 4, 0.24)";
        paint.fillRect(board.x, board.y, board.width, board.height);
        paint.restore();
      }

      function drawSilverRail(x1, y1, x2, y2, width, paint = ctx) {
        const horizontal = y1 === y2;
        const gradient = horizontal
          ? paint.createLinearGradient(0, y1 - width / 2, 0, y1 + width / 2)
          : paint.createLinearGradient(x1 - width / 2, 0, x1 + width / 2, 0);
        gradient.addColorStop(0, "#7d888e");
        gradient.addColorStop(0.35, "#f6fafb");
        gradient.addColorStop(0.7, "#b5c0c5");
        gradient.addColorStop(1, "#68747a");
        paint.strokeStyle = gradient;
        paint.lineWidth = width;
        paint.lineCap = "round";
        paint.beginPath();
        paint.moveTo(x1, y1);
        paint.lineTo(x2, y2);
        paint.stroke();
      }

      function drawHook(x, y, direction, paint = ctx) {
        paint.save();
        paint.translate(x, y);
        paint.scale(direction, 1);
        paint.strokeStyle = "#48df20";
        paint.lineWidth = 7;
        paint.lineCap = "round";
        paint.beginPath();
        paint.moveTo(0, 0);
        paint.lineTo(12, 0);
        paint.bezierCurveTo(23, 0, 23, 18, 11, 18);
        paint.lineTo(2, 18);
        paint.stroke();
        paint.restore();
      }

      function drawNet(board, paint = ctx) {
        const cellWidth = board.width / columns;
        const cellHeight = board.height / rows;
        drawSilverRail(board.x - 21, board.y, board.x - 21, board.y + board.height, 18, paint);
        drawSilverRail(board.x + board.width + 21, board.y, board.x + board.width + 21, board.y + board.height, 18, paint);
        drawSilverRail(board.x, board.y - 20, board.x + board.width, board.y - 20, 16, paint);
        drawSilverRail(board.x, board.y + board.height + 20, board.x + board.width, board.y + board.height + 20, 16, paint);

        paint.strokeStyle = "#63e82f";
        paint.lineWidth = 4;
        paint.lineCap = "round";
        paint.shadowColor = "rgba(67, 237, 36, 0.28)";
        paint.shadowBlur = 3;

        for (let row = 0; row <= rows; row += 1) {
          const y = board.y + row * cellHeight;
          const sag = row === 0 || row === rows ? 0 : 3 + (row % 2);
          paint.beginPath();
          paint.moveTo(board.x, y);
          paint.quadraticCurveTo(board.x + board.width / 2, y + sag, board.x + board.width, y);
          paint.stroke();
          drawHook(board.x - 27, y - 9, -1, paint);
          drawHook(board.x + board.width + 27, y - 9, 1, paint);
        }

        for (let column = 0; column <= columns; column += 1) {
          const x = board.x + column * cellWidth;
          const bend = column === 0 || column === columns ? 0 : column % 2 ? -2 : 2;
          paint.beginPath();
          paint.moveTo(x, board.y);
          paint.quadraticCurveTo(x + bend, board.y + board.height / 2, x, board.y + board.height);
          paint.stroke();
        }

        paint.shadowBlur = 0;
        paint.fillStyle = "#74ef39";
        for (let row = 0; row <= rows; row += 1) {
          for (let column = 0; column <= columns; column += 1) {
            paint.beginPath();
            paint.arc(board.x + column * cellWidth, board.y + row * cellHeight, 4.3, 0, Math.PI * 2);
            paint.fill();
          }
        }

        paint.fillStyle = "#38c71a";
        const corners = [
          [board.x - 30, board.y - 29],
          [board.x + board.width + 8, board.y - 29],
          [board.x - 30, board.y + board.height + 8],
          [board.x + board.width + 8, board.y + board.height + 8]
        ];
        corners.forEach(([x, y]) => {
          paint.beginPath();
          paint.roundRect(x, y, 22, 22, 5);
          paint.fill();
        });
      }

      function drawTarget(target, now, board) {
        const cellWidth = board.width / columns;
        const cellHeight = board.height / rows;
        const x = board.x + target.column * cellWidth + cellWidth / 2;
        const y = board.y + target.row * cellHeight + cellHeight / 2;
        const age = now - target.createdAt;
        const remainingRatio = Math.max(0, 1 - age / target.lifetime);
        const pulse = 1 + Math.sin(age / 115) * 0.06;
        const mobileRadius = isCompactInput() ? 14 * canvas.width / canvas.getBoundingClientRect().width : 18;
        const radius = Math.max(mobileRadius, Math.min(38, Math.min(cellWidth, cellHeight) * 0.31)) * pulse;

        ctx.save();
        ctx.translate(x, y);
        const isPink = target.kind === "pink";
        const isGold = target.kind === "gold";
        ctx.fillStyle = isGold
          ? "rgba(255, 196, 0, 0.27)"
          : isPink
            ? "rgba(237, 0, 140, 0.22)"
            : "rgba(112, 191, 37, 0.22)";
        ctx.strokeStyle = isGold ? "#ffc400" : isPink ? "#ed008c" : "#a5ef46";
        ctx.lineWidth = remainingRatio < 0.3 ? 7 : 4;
        ctx.beginPath();
        ctx.arc(0, 0, radius + 10, 0, Math.PI * 2);
        ctx.fill();
        ctx.stroke();

        if (remainingRatio < 0.3) {
          ctx.strokeStyle = "#ff596d";
          ctx.beginPath();
          ctx.arc(0, 0, radius + 17, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * remainingRatio);
          ctx.stroke();
        }

        drawLeafCluster(0, 0, radius, age / 900, isGold ? 4 : isPink ? 2 : 0, 1);
        if (isPink || isGold) {
          ctx.fillStyle = "#fff";
          ctx.font = "900 14px Segoe UI, sans-serif";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(isGold ? "+200 g" : "+150 g", 0, 0);
        }
        ctx.restore();
      }

      function drawFeedback(item, now) {
        const age = now - item.createdAt;
        const progress = age / 720;
        ctx.save();
        ctx.globalAlpha = Math.max(0, 1 - progress);
        ctx.fillStyle = item.kind === "gold" ? "#ffd83d" : item.kind === "pink" ? "#ff34ad" : "#b1ff5b";
        ctx.font = "900 28px Segoe UI, sans-serif";
        ctx.textAlign = "center";
        ctx.fillText(`+${item.points} g`, item.x, item.y - progress * 46);
        ctx.restore();
      }

      function prepareScenery(board) {
        if (sceneryCache) return;
        // Rasterize static scenery once per grid or canvas size, not once per frame.
        const background = document.createElement("canvas");
        const net = document.createElement("canvas");
        for (const layer of [background, net]) {
          layer.width = canvas.width;
          layer.height = canvas.height;
        }
        drawCanopy(board, background.getContext("2d"));
        drawNet(board, net.getContext("2d"));
        sceneryCache = { background, net };
      }

      function render(now = performance.now()) {
        const board = getBoard();
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        prepareScenery(board);
        ctx.drawImage(sceneryCache.background, 0, 0);
        targets.forEach((target) => drawTarget(target, now, board));
        ctx.drawImage(sceneryCache.net, 0, 0);
        feedback.forEach((item) => drawFeedback(item, now));
      }

      function spawnTarget(now) {
        const current = LEVELS[level - 1];
        const maximum = current.maximum + (roundElapsed >= ROUND_DURATION / 2 ? 2 : 0);
        if (targets.length >= maximum) return;

        const available = [];
        const spacing = isCompactInput() ? targetSpacing(getBoard()) : null;
        for (let row = 0; row < rows; row += 1) {
          for (let column = 0; column < columns; column += 1) {
            const occupied = targets.some((target) => spacing
              ? Math.hypot((target.column - column) * spacing.x, (target.row - row) * spacing.y) < 48
              : target.row === row && target.column === column);
            if (!occupied) {
              available.push({ row, column });
            }
          }
        }
        if (!available.length) return;

        const spot = available[Math.floor(Math.random() * available.length)];
        const typeRoll = Math.random();
        const kind = typeRoll < 0.06 ? "gold" : typeRoll < 0.24 ? "pink" : "green";
        targets.push({
          ...spot,
          kind,
          createdAt: now,
          lifetime: current.lifetime * (0.72 + Math.random() * 0.62)
        });
      }

      function getNextSpawnDelay(config) {
        const phaseFactor = roundElapsed >= ROUND_DURATION / 2 ? 0.64 : 1;
        const randomFactor = 0.68 + Math.random() * 0.68;
        return config.interval * phaseFactor * randomFactor;
      }

      function spawnWave(now) {
        let count = 1;
        if (roundElapsed >= ROUND_DURATION / 2 && Math.random() < 0.42) {
          count = Math.random() < 0.14 ? 3 : 2;
        }
        for (let index = 0; index < count; index += 1) spawnTarget(now);
      }

      function setRound(roundNumber, announce = false) {
        level = roundNumber;
        const config = LEVELS[level - 1];
        columns = config.columns;
        rows = config.rows;
        roundElapsed = 0;
        misses = 0;
        spawnAccumulator = 0;
        nextSpawnDelay = getNextSpawnDelay(config);
        targets = [];
        feedback = [];
        rebuildCanopy();

        if (announce) {
          playSound("round");
          screenReaderState.textContent = `Runde ${level}. ${columns} mal ${rows}. Jetzt wird es schneller.`;
        }
      }

      function updateGame(delta, now) {
        roundElapsed += delta;
        const current = LEVELS[level - 1];
        spawnAccumulator += delta;

        if (spawnAccumulator >= nextSpawnDelay) {
          spawnAccumulator = 0;
          spawnWave(now);
          nextSpawnDelay = getNextSpawnDelay(current);
        }

        let missedThisFrame = false;
        for (let index = targets.length - 1; index >= 0; index -= 1) {
          if (now - targets[index].createdAt >= targets[index].lifetime) {
            targets.splice(index, 1);
            misses += 1;
            score = Math.max(0, score - 50);
            missedThisFrame = true;
          }
        }
        if (missedThisFrame) playSound("miss");

        feedback = feedback.filter((item) => now - item.createdAt < 720);

        if (misses >= MAX_MISSES) {
          finishGame(false);
        } else if (roundElapsed >= ROUND_DURATION) {
          if (level < LEVELS.length) {
            setRound(level + 1, true);
            spawnTarget(now);
          } else {
            finishGame(true);
          }
        }
      }

      function frame(now) {
        if (mode !== "running") return;
        const delta = Math.max(0, now - lastFrame);
        lastFrame = now;
        updateGame(delta, now);
        render(now);
        updateHud();
        if (mode === "running") animationFrame = requestAnimationFrame(frame);
      }

      function setHudValue(element, value, html = false) {
        if (hudValues.get(element) === value) return;
        hudValues.set(element, value);
        if (html) element.innerHTML = value;
        else element.textContent = value;
      }

      function updateHud() {
        const remaining = Math.max(0, ROUND_DURATION - roundElapsed);
        const seconds = Math.ceil(remaining / 1000);
        const minutesPart = Math.floor(seconds / 60);
        const secondsPart = seconds % 60;
        const percent = Math.min(100, Math.max(0, (roundElapsed / ROUND_DURATION) * 100));
        setHudValue(scoreValue, score.toLocaleString("de-DE"));
        setHudValue(timeValue, `${String(minutesPart).padStart(2, "0")}:${String(secondsPart).padStart(2, "0")}`);
        setHudValue(levelValue, String(level).padStart(2, "0"));
        setHudValue(missesValue, String(misses));
        setHudValue(gridValue, `Betternet ${columns} × ${rows}`);
        progressFill.style.transform = `scaleX(${percent / 100})`;
        progressTrack.setAttribute("aria-valuenow", String(Math.round(percent)));

        if (mode === "running") {
          const phase = roundElapsed >= ROUND_DURATION / 2 ? "intensive Blüte" : "frühe Blüte";
          setHudValue(statusLine, `Runde ${level} / ${LEVELS.length} · ${phase}`);
          setHudValue(primaryButton, "Neu starten <span aria-hidden=\"true\">↻</span>", true);
        } else if (mode === "paused") {
          setHudValue(statusLine, "Spiel pausiert.");
          setHudValue(primaryButton, "Neu starten");
        } else if (mode === "ended") {
          setHudValue(statusLine, "Runde beendet · Highscore offen.");
          setHudValue(primaryButton, "Nochmal spielen <span aria-hidden=\"true\">↻</span>", true);
        } else {
          setHudValue(statusLine, "Fünf Fehlversuche sind pro Runde erlaubt.");
          setHudValue(primaryButton, "Spielen <span aria-hidden=\"true\">▶</span>", true);
        }
      }

      function resetGame() {
        scoreGeneration++;
        savingHighscore = false;
        highscoreSaved = false;
        highscores.start();
        cancelAnimationFrame(animationFrame);
        if (typeof window.clearTimeout === "function") window.clearTimeout(resultActionTimer);
        resultActionsReadyAt = 0;
        score = 0;
        rewardEligible = false;
        pausedAt = 0;
        resetNewsletter();
        setRound(1);
        mode = "running";
        overlay.hidden = true;
        highscoreOverlay.hidden = true;
        if (highscoreOverlay.open) highscoreOverlay.close();
        highscoreOverlay.classList.remove("browse-mode");
        playArea.inert = false;
        root.querySelector(".hud").inert = false;
        scoreForm.hidden = false;
        newsletterForm.hidden = false;
        resultEntryActions.hidden = false;
        scoreForm.reset();
        formMessage.textContent = "";
        saveScoreButton.disabled = false;
        skipScoreButton.disabled = false;
        saveScoreButton.textContent = "Highscore eintragen";
        skipScoreButton.textContent = "Ohne Eintrag nochmal";
        lastSavedEntry = null;
        pauseButton.disabled = false;
        pauseButton.classList.remove("is-resume");
        pauseButtonLabel.textContent = "Pause";
        pauseButton.title = "Pause";
        pauseButton.setAttribute("aria-label", "Spiel pausieren");
        lastFrame = performance.now();
        spawnTarget(lastFrame);
        playSound("start");
        startBackgroundMusic(true);
        updateHud();
        screenReaderState.textContent = "Spiel gestartet. Runde 1 mit 6 mal 6 Feldern. Eine Minute Zeit.";
        canvas.focus({ preventScroll: true });
        animationFrame = requestAnimationFrame(frame);
      }

      function pauseGame(fromVisibility = false) {
        if (mode !== "running") return;
        mode = "paused";
        pausedAt = performance.now();
        cancelAnimationFrame(animationFrame);
        pauseBackgroundMusic();
        overlayTitle.textContent = "Pause";
        overlayText.textContent = fromVisibility
          ? "Das Spiel wurde beim Verlassen des Tabs automatisch pausiert."
          : "Deine Runde wartet auf dich.";
        overlayButton.textContent = "Weiterspielen";
        overlay.hidden = false;
        pauseButton.classList.add("is-resume");
        pauseButtonLabel.textContent = "Weiter";
        pauseButton.title = "Weiterspielen";
        pauseButton.setAttribute("aria-label", "Spiel fortsetzen");
        updateHud();
      }

      function resumeGame() {
        if (mode !== "paused") return;
        const pausedDuration = performance.now() - pausedAt;
        targets.forEach((target) => { target.createdAt += pausedDuration; });
        feedback.forEach((item) => { item.createdAt += pausedDuration; });
        pausedAt = 0;
        mode = "running";
        overlay.hidden = true;
        pauseButton.classList.remove("is-resume");
        pauseButtonLabel.textContent = "Pause";
        pauseButton.title = "Pause";
        pauseButton.setAttribute("aria-label", "Spiel pausieren");
        lastFrame = performance.now();
        updateHud();
        startBackgroundMusic();
        canvas.focus({ preventScroll: true });
        animationFrame = requestAnimationFrame(frame);
      }

      async function renderLeaderboard() {
        const request = ++leaderboardRequest;
        leaderboardStatus.textContent = "Rangliste wird geladen …";
        clearScoresButton.disabled = true;
        try {
          const entries = await highscores.list();
          if (request !== leaderboardRequest) return;
          leaderboardList.replaceChildren();
          leaderboardStatus.textContent = entries.length ? "Gemeinsame Top 10 · Gramm ist ein Spielwert" : "Noch keine Einträge – hol dir Platz 1!";
          entries.forEach((entry, index) => {
            const item = document.createElement("li");
            item.className = "leaderboard-entry";
            if (lastSavedEntry && entry.id === lastSavedEntry.id) item.classList.add("is-current");
            const rank = document.createElement("span");
            rank.className = "rank"; rank.textContent = (index + 1) + ".";
            const name = document.createElement("span");
            name.className = "player-name"; name.textContent = entry.name;
            const result = document.createElement("span");
            result.className = "player-score"; result.textContent = entry.score.toLocaleString("de-DE") + " g";
            item.append(rank, name, result); leaderboardList.append(item);
          });
        } catch (error) {
          if (request !== leaderboardRequest) return;
          leaderboardList.replaceChildren();
          leaderboardStatus.textContent = error.message;
        } finally { if (request === leaderboardRequest) clearScoresButton.disabled = false; }
      }

      function markHighscoreSaved() {
        highscoreSaved = true;
        saveScoreButton.disabled = true;
        saveScoreButton.textContent = "Eingetragen";
        skipScoreButton.textContent = "Nochmal spielen";
        formMessage.textContent = "Deine Ernte ist dauerhaft gespeichert. Die Rangliste zeigt die besten 10 Ergebnisse.";
      }

      async function saveHighscore(event) {
        event.preventDefault();
        if (mode !== "ended" || savingHighscore || highscoreSaved || performance.now() < resultActionsReadyAt) return;
        const name = playerName.value.trim();
        if (!/^[\p{L}\p{N} _.-]{1,24}$/u.test(name)) {
          playerName.setCustomValidity("Nutze 1–24 Buchstaben, Zahlen, Leerzeichen, Punkt, Bindestrich oder Unterstrich.");
          playerName.reportValidity(); return;
        }
        playerName.setCustomValidity("");
        const current = scoreGeneration;
        const result = { name, score, elapsedMs: Math.round((level - 1) * ROUND_DURATION + Math.min(ROUND_DURATION, roundElapsed)) };
        savingHighscore = true;
        saveScoreButton.disabled = true;
        saveScoreButton.textContent = "Wird gespeichert …";
        formMessage.textContent = "";
        try {
          const entry = await highscores.save(result);
          if (current !== scoreGeneration) return;
          lastSavedEntry = entry;
          markHighscoreSaved();
          renderLeaderboard();
        } catch (error) {
          if (current !== scoreGeneration) return;
          formMessage.textContent = error.message;
          saveScoreButton.disabled = false;
          saveScoreButton.textContent = "Erneut speichern";
        } finally { if (current === scoreGeneration) savingHighscore = false; }
      }

      function showHarvestResult(completed) {
        const category = completed ? "completed" : score < 1000 ? "small" : score < 5000 ? "medium" : "large";
        const choices = HARVEST_QUIPS[category].filter((quip) => quip !== lastHarvestQuip);
        const quip = choices[Math.floor(Math.random() * choices.length)];
        lastHarvestQuip = quip;
        resultHeading.textContent = quip[0];
        resultCopy.textContent = `Du hast ${score.toLocaleString("de-DE")} g geerntet. ${quip[1]}`;
      }

      function finishGame(completed) {
        mode = "ended";
        highscoreSaved = false;
        rewardEligible = completed && level >= 3;
        resetNewsletter();
        cancelAnimationFrame(animationFrame);
        pauseBackgroundMusic(true);
        targets = [];
        pauseButton.disabled = true;
        overlay.hidden = true;
        highscoreOverlay.classList.remove("browse-mode");
        showHarvestResult(completed);
        scoreForm.reset();
        scoreForm.hidden = false;
        newsletterForm.hidden = false;
        resultEntryActions.hidden = false;
        formMessage.textContent = "";
        saveScoreButton.disabled = true;
        skipScoreButton.disabled = true;
        saveScoreButton.textContent = "Highscore eintragen";
        skipScoreButton.textContent = "Ohne Eintrag nochmal";
        lastSavedEntry = null;
        renderLeaderboard();
        highscoreOverlay.hidden = false;
        if (!highscoreOverlay.open) highscoreOverlay.showModal();
        dialogReturnFocus = openHighscoreButton;
        playArea.inert = true;
        root.querySelector(".hud").inert = true;
        playSound(completed ? "finish" : "end");
        screenReaderState.textContent = `${resultHeading.textContent}. ${resultCopy.textContent}`;
        updateHud();
        render();
        resultActionsReadyAt = performance.now() + 700;
        resultActionTimer = window.setTimeout(() => {
          saveScoreButton.disabled = highscoreSaved;
          skipScoreButton.disabled = false;
          if (isCompactInput()) {
            resultHeading.tabIndex = -1;
            resultHeading.focus({ preventScroll: true });
          } else {
            playerName.focus({ preventScroll: true });
          }
        }, 700);
      }

      function activateCell(event) {
        if (mode !== "running") return;
        event.preventDefault();

        const rect = canvas.getBoundingClientRect();
        const canvasX = (event.clientX - rect.left) * (canvas.width / rect.width);
        const canvasY = (event.clientY - rect.top) * (canvas.height / rect.height);
        const board = getBoard();
        if (canvasX < board.x || canvasX >= board.x + board.width || canvasY < board.y || canvasY >= board.y + board.height) return;

        const cellWidth = board.width / columns;
        const cellHeight = board.height / rows;
        const column = Math.floor((canvasX - board.x) / cellWidth);
        const row = Math.floor((canvasY - board.y) / cellHeight);
        let targetIndex = targets.findIndex((target) => target.column === column && target.row === row);
        if (isCompactInput()) {
          let nearestDistance = 24;
          targetIndex = -1;
          targets.forEach((target, index) => {
            const targetX = board.x + (target.column + 0.5) * cellWidth;
            const targetY = board.y + (target.row + 0.5) * cellHeight;
            const distance = Math.hypot((canvasX - targetX) * rect.width / canvas.width, (canvasY - targetY) * rect.height / canvas.height);
            if (distance <= nearestDistance) {
              nearestDistance = distance;
              targetIndex = index;
            }
          });
        }
        if (targetIndex === -1) return;

        const target = targets[targetIndex];
        const points = target.kind === "gold" ? 200 : target.kind === "pink" ? 150 : 50;
        score += points;
        feedback.push({
          x: board.x + column * cellWidth + cellWidth / 2,
          y: board.y + row * cellHeight + cellHeight / 2,
          points,
          kind: target.kind,
          createdAt: performance.now()
        });
        targets.splice(targetIndex, 1);
        playCutSound();
        if (target.kind === "gold") playSound("gold");
        else if (target.kind === "pink") playSound("bonus");
        updateHud();
      }

      primaryButton.addEventListener("click", resetGame);
      overlayButton.addEventListener("click", () => {
        if (mode === "paused") resumeGame();
        else resetGame();
      });
      pauseButton.addEventListener("click", () => {
        if (mode === "running") pauseGame();
        else if (mode === "paused") resumeGame();
      });
      soundButton.addEventListener("click", () => {
        soundEnabled = !soundEnabled;
        soundButton.classList.toggle("is-muted", !soundEnabled);
        soundButtonLabel.textContent = soundEnabled ? "Musik an" : "Musik aus";
        soundButton.title = soundEnabled ? "Musik an" : "Musik aus";
        soundButton.setAttribute("aria-pressed", String(soundEnabled));
        soundButton.setAttribute("aria-label", soundEnabled ? "Sound ausschalten" : "Sound einschalten");
        if (soundEnabled) {
          playSound("hit");
          startBackgroundMusic();
        } else {
          pauseBackgroundMusic();
          cutSound.pause();
          cutSound.currentTime = 0;
        }
      });
      newsletterForm.addEventListener("submit", submitNewsletter, { signal: lifecycle.signal });
      openHighscoreButton.addEventListener("click", showHighscore);
      closeHighscoreButton.addEventListener("click", closeHighscore);
      inviteButton.addEventListener("click", inviteFriends);
      resultInviteButton.addEventListener("click", inviteFriends);
      playerName.addEventListener("input", () => playerName.setCustomValidity(""));
      scoreForm.addEventListener("submit", saveHighscore);
      skipScoreButton.addEventListener("click", resetGame);
      clearScoresButton.addEventListener("click", renderLeaderboard);
      shopButton.addEventListener("click", () => {
        window.location.assign(host.dataset.shopUrl);
      });
      canvas.addEventListener("pointerdown", activateCell);
      canvas.addEventListener("keydown", (event) => {
        if (event.key === " " || event.key === "Enter") {
          event.preventDefault();
          if (mode === "running") pauseGame();
          else if (mode === "paused") resumeGame();
          else resetGame();
        }
      });
      document.addEventListener("visibilitychange", () => {
        if (document.hidden) pauseGame(true);
      }, { signal: lifecycle.signal });
      root.addEventListener("keydown", (event) => {
        if (highscoreOverlay.hidden) return;
        if (event.key === "Escape") {
          event.preventDefault();
          closeHighscore();
        }
      });

      const sizeObserver = new ResizeObserver(configureBoard);
      sizeObserver.observe(host);
      const visibilityObserver = new IntersectionObserver(([entry]) => { if (!entry.isIntersecting) pauseGame(true); });
      visibilityObserver.observe(host);

      newsletterBackend = connectScrogNewsletter(newsletterForm,
        () => ({ score, level, misses, roundElapsed: Math.min(ROUND_DURATION, roundElapsed), eligible: rewardEligible, highscoreSaved }),
        (saved) => {
          highscores.restore();
          setRound(saved.level);
          score = saved.score;
          misses = saved.misses;
          roundElapsed = saved.roundElapsed;
          finishGame(saved.eligible);
          if (saved.highscoreSaved === true) markHighscoreSaved();
        },
        () => { rewardCode.textContent = REWARD_CODE; rewardBox.hidden = false; },
        () => {
          // Shopify CAPTCHA may open outside the dialog; remove native modal inertness during submission.
          if (highscoreOverlay.open) { highscoreOverlay.close(); highscoreOverlay.show(); }
        }
      );
      configureBoard();
      updateHud();
      render();
      newsletterBackend.resume();
    return () => { scoreGeneration++; leaderboardRequest++; highscores.dispose(); cancelAnimationFrame(animationFrame); pauseBackgroundMusic(true); cutSound.pause(); window.clearTimeout(resultActionTimer); newsletterBackend.dispose(); lifecycle.abort(); sizeObserver.disconnect(); visibilityObserver.disconnect(); if (audioContext) audioContext.close().catch(() => {}); };
}

if (!customElements.get("growber-scrog-hero")) {
  customElements.define("growber-scrog-hero", class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const template = this.querySelector("template");
      if (!template) return;
      const root = this.shadowRoot || this.attachShadow({ mode: "open" });
      root.replaceChildren(template.content.cloneNode(true));
      this.cleanup = mountScrogGame(root, this);
    }
    disconnectedCallback() { if (this.cleanup) this.cleanup(); this.cleanup = null; }
  });
}
